(function(){
  var $=function(id){return document.getElementById(id)};
  var IMG=window.AS2_IMG||{};
  var isPw=document.body.classList.contains('pw');
  var EMAIL=/^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var kit=[
    {n:'Windbreaker',f:'k47.jpg'},{n:'Rugby Jersey',f:'k31.jpg'},{n:'Sweatshirt',f:'k37.jpg'},
    {n:'1/4 Zip',f:'k41.jpg'},{n:'Long Sleeve T',f:'k43.jpg'},{n:'Short Sleeve T',f:'k45.jpg'},
    {n:'Full Zip Trackies',f:'k39.jpg'},{n:'Training Shorts',f:'k29.jpg'},{n:'Sports Tote',f:'k33.jpg'}
  ];

  // Dark mode
  var themeBtn=$('themeBtn');
  function applyTheme(dark){
    if(dark)document.documentElement.setAttribute('data-site-theme','dark');else document.documentElement.removeAttribute('data-site-theme');
    if(!themeBtn)return;
    themeBtn.setAttribute('aria-pressed',String(dark));
    themeBtn.setAttribute('aria-label',dark?'Switch to light mode':'Switch to dark mode');
    themeBtn.title=dark?'Light mode':'Dark mode';
  }
  var saved=null;try{saved=localStorage.getItem('as_theme')}catch(_){}
  applyTheme(saved==='dark');
  if(themeBtn)themeBtn.addEventListener('click',function(){
    var dark=document.documentElement.getAttribute('data-site-theme')!=='dark';
    applyTheme(dark);try{localStorage.setItem('as_theme',dark?'dark':'light')}catch(_){}
  });

  // Kit strip and kit grid
  var track=$('track');
  if(track){
    var html=kit.map(function(k){return '<div class="piece"><div class="ph"><img src="'+IMG[k.f]+'" alt="'+k.n+'" loading="lazy"></div><p>'+k.n+'</p></div>'}).join('');
    track.innerHTML=html+html.replace(/alt="[^"]*"/g,'alt="" aria-hidden="true"');
  }
  var grid=$('kitGrid');
  if(grid)grid.innerHTML=kit.map(function(k,i){return '<div class="kit-item"><div class="ph"><img src="'+IMG[k.f]+'" alt="'+k.n+'" loading="lazy"></div><div class="row"><span>'+k.n+'</span><span>0'+(i+1)+' / 09</span></div></div>'}).join('');

  // Stories: every card links somewhere real (u = link, cta = label)
  var postsEl=$('posts');
  var stashCta=(postsEl&&postsEl.dataset.stashCta)||'Preview your stash';
  var posts=[
    {c:'kit',l:'The kit',t:'Meet the kit: all nine pieces',img:'k31.jpg',p:1,u:'/pages/the-kit',cta:'See the kit →'},
    {c:'club',l:'Clubhouse',t:'Why we call it the Third Half',img:'apres.jpg',u:'/blogs/the-archive/why-we-call-it-the-third-half',cta:'Read the story →'},
    {c:'kit',l:'The kit',t:'What comes in the box',img:'stash-grid.jpg',u:'/pages/the-kit#in-the-box',cta:'Look inside →'},
    {c:'partners',l:'Partners',t:'Becoming a local partner',img:'partner.jpg',u:'/pages/founding-partners',cta:'Find out more →'},
    {c:'club',l:'Clubhouse',t:'Post an ad on the Noticeboard',img:'stamp.jpg',u:'/pages/post-an-ad',cta:'Post an ad →'},
    {c:'kit',l:'The kit',t:'One box, one number: 001 to 100',img:'box.jpg',p:1,u:'/pages/the-kit#in-the-box',cta:stashCta+' →'}
  ];
  if(postsEl){var pd=postsEl.dataset;if(pd.partnerImg)IMG['partner.jpg']=pd.partnerImg;if(pd.stampImg)IMG['stamp.jpg']=pd.stampImg;if(pd.apresImg)IMG['apres.jpg']=pd.apresImg;if(pd.gridImg)IMG['stash-grid.jpg']=pd.gridImg;if(pd.boxImg)IMG['box.jpg']=pd.boxImg;}
  function renderPosts(f){
    if(!postsEl)return;
    postsEl.innerHTML=posts.filter(function(p){return f==='all'||p.c===f}).map(function(p){
      return '<a class="post" href="'+p.u+'"><div class="ph"><img class="'+(p.p?'prod':'')+'" src="'+IMG[p.img]+'" alt="" loading="lazy"></div><div class="meta"><span>'+p.l+'</span><span>'+p.cta+'</span></div><h3>'+p.t+'</h3></a>';
    }).join('');
  }
  renderPosts('all');
  document.querySelectorAll('.filters button[data-f]').forEach(function(b){
    b.addEventListener('click',function(){
      document.querySelectorAll('.filters button[data-f]').forEach(function(x){x.setAttribute('aria-pressed',String(x===b))});
      renderPosts(b.dataset.f);
    });
  });

  // Stash selector (home). Mode comes from the as2-stash snippet: preview | presale | checkout
  var stashBtn=$('stashBtn'),stashDlg=$('stashDlg');
  function closeStash(){if(stashDlg){stashDlg.hidden=true;if(stashBtn)stashBtn.focus()}}
  if(stashBtn){
    var mode=stashBtn.dataset.mode||'preview',btnLabel=stashBtn.textContent;
    var stashImg=$('stashImg'),stashSum=$('stashSum'),stashPrice=$('stashPrice');
    var vmap={};try{var vj=$('stashVariants');if(vj)vmap=JSON.parse(vj.textContent)}catch(_){}
    document.querySelectorAll('.stash-tog button[data-v]').forEach(function(b){b.addEventListener('click',function(){stashImg.src=b.dataset.v;stashImg.alt='The Rugby Jersey, '+b.textContent.toLowerCase()+' view';document.querySelectorAll('.stash-tog button[data-v]').forEach(function(x){x.setAttribute('aria-pressed',String(x===b))})})});
    var tier=function(){return document.querySelector('input[name=tier]:checked')};
    var size=function(){var s=document.querySelector('input[name=size]:checked');return s?s.value:''};
    var variantFor=function(t,s){return vmap[t+'/'+s]};
    var upd=function(){
      var t=tier(),s=size(),ok=!!s;
      stashPrice.textContent='£'+t.dataset.p;
      if(mode!=='preview'){
        document.querySelectorAll('input[name=size]').forEach(function(i){var v=variantFor(t.value,i.value);var na=!v||!v.a;i.disabled=na;i.parentNode.classList.toggle('na',na);if(na&&i.checked){i.checked=false}});
        s=size();ok=!!s;
      }
      stashSum.textContent=s?(t.value+' bundle · Size '+s+' · 9 pieces'):(mode==='preview'?'Choose your size to preview your stash.':'Choose your size to continue.');
      stashBtn.disabled=!ok;
    };
    document.querySelectorAll('input[name=tier],input[name=size]').forEach(function(i){i.addEventListener('change',upd)});
    stashBtn.addEventListener('click',function(){
      var t=tier();
      if(mode==='preview'){$('sdTier').textContent=t.value;$('sdSize').textContent=size();$('sdPrice').textContent='£'+t.dataset.p;stashDlg.hidden=false;$('sdClose').focus();return}
      var v=variantFor(t.value,size());
      if(!v||!v.a){stashSum.textContent='Sorry, that size is not available right now.';return}
      stashBtn.disabled=true;stashBtn.textContent='Adding…';
      var props=mode==='presale'?{'Pre-order':'Drop 1, handed over on kit day'}:{};
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:1,properties:props}]})})
        .then(function(r){if(!r.ok)throw new Error('add');return r.json()})
        .then(function(){window.location.href='/cart'})
        .catch(function(){stashBtn.disabled=false;stashBtn.textContent=btnLabel;stashSum.textContent='Something went wrong adding your kit. Please try again, or email alumni@alumnisport.co.uk.'});
    });
    upd();
  }
  if(stashDlg){
    $('sdClose').addEventListener('click',closeStash);
    $('sdBack').addEventListener('click',closeStash);
    stashDlg.addEventListener('click',function(e){if(e.target===stashDlg)closeStash()});
    var sdJoin=stashDlg.querySelector('a[href="#join"]');if(sdJoin)sdJoin.addEventListener('click',function(){stashDlg.hidden=true});
  }

  // All pages panel: opened by the header pill (desktop) or the menu button (mobile)
  var mega=$('mega'),toggles=[].slice.call(document.querySelectorAll('[data-mega-toggle]'));
  function setMenu(open){if(!mega)return;mega.hidden=!open;toggles.forEach(function(t){t.setAttribute('aria-expanded',String(open))})}
  function closeMenu(){setMenu(false)}
  function visibleToggle(){for(var i=0;i<toggles.length;i++){if(toggles[i].offsetParent)return toggles[i]}return null}
  toggles.forEach(function(t){t.addEventListener('click',function(e){e.stopPropagation();setMenu(mega.hidden)})});
  if(mega){
    mega.addEventListener('click',function(e){if(e.target===mega||e.target.closest('a'))closeMenu()});
    document.addEventListener('click',function(e){if(!mega.hidden&&!mega.contains(e.target))closeMenu()});
  }

  // Email forms: check the address before Shopify submits it
  function guard(formId,inputId,msgId,onOk){
    var f=$(formId);if(!f)return;
    f.addEventListener('submit',function(e){
      var v=$(inputId).value.trim();
      if(!EMAIL.test(v)){e.preventDefault();$(msgId).textContent='Enter an email address like name@example.com.';return}
      if(onOk)onOk();
    });
  }
  guard('signup','email','msg');
  guard('pwSignup','pwEmail','pwMsg');

  // Coming-soon page
  var pwDialog=$('pwDialog');
  if(pwDialog){
    $('pwWhat').addEventListener('click',function(){pwDialog.hidden=false;$('pwClose').focus()});
    $('pwClose').addEventListener('click',function(){pwDialog.hidden=true;$('pwWhat').focus()});
    pwDialog.addEventListener('click',function(e){if(e.target===pwDialog)pwDialog.hidden=true});
  }
  var passBtn=$('pwPassBtn'),passForm=$('pwPassForm');
  if(passBtn&&passForm){
    if(passForm.querySelector('.as2-form-note'))passForm.hidden=false;
    passBtn.addEventListener('click',function(){passForm.hidden=!passForm.hidden;passBtn.setAttribute('aria-expanded',String(!passForm.hidden));if(!passForm.hidden)$('pwPassword').focus()});
  }

  // Welcome pop-up: once per visitor
  var welcome=$('welcome'),lastFocus=null;
  function seen(){try{return localStorage.getItem('as_welcome_seen')==='1'}catch(_){return false}}
  function markSeen(){try{localStorage.setItem('as_welcome_seen','1')}catch(_){}}
  function openWelcome(){if(isPw||!welcome)return;lastFocus=document.activeElement;welcome.hidden=false;$('welcomeEmail').focus()}
  function closeWelcome(){if(!welcome)return;welcome.hidden=true;markSeen();if(lastFocus&&lastFocus.focus)lastFocus.focus()}
  if(welcome){
    $('welcomeClose').addEventListener('click',closeWelcome);
    $('welcomeSkip').addEventListener('click',closeWelcome);
    welcome.addEventListener('click',function(e){if(e.target===welcome)closeWelcome()});
    guard('welcomeForm','welcomeEmail','welcomeMsg',markSeen);
  }
  document.querySelectorAll('[data-welcome]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();openWelcome()})});

  // Intro curtain: once per browser session (also on the coming-soon page)
  var intro=$('intro'),played=false;
  try{played=sessionStorage.getItem('as_intro')==='1'}catch(_){}
  var showIntro=intro&&!played&&!/customer_posted|form_type|password=/.test(location.search);
  function endIntro(){
    if(!intro||intro.classList.contains('done')||intro.hidden)return;
    intro.classList.add('done');document.body.classList.remove('intro-on');
    try{sessionStorage.setItem('as_intro','1')}catch(_){}
    setTimeout(function(){intro.hidden=true},900);
  }
  if(showIntro){
    document.body.classList.add('intro-on');
    var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(endIntro,reduce?900:2500);
    intro.addEventListener('click',endIntro);
    document.addEventListener('keydown',function k(){endIntro();document.removeEventListener('keydown',k)});
  }else if(intro){intro.hidden=true}
  if(!seen()&&!/customer_posted|contact_posted/.test(location.search)&&location.hash!=='#stash')setTimeout(openWelcome,showIntro?3800:1200);
  var replay=$('replayIntro');
  if(replay&&intro)replay.addEventListener('click',function(e){
    e.preventDefault();window.scrollTo(0,0);
    var fresh=intro.cloneNode(true);intro.parentNode.replaceChild(fresh,intro);intro=fresh;
    intro.hidden=false;intro.classList.remove('done');document.body.classList.add('intro-on');
    intro.addEventListener('click',endIntro);setTimeout(endIntro,2500);
  });

  // Escape closes whatever is open
  document.addEventListener('keydown',function(e){
    if(e.key!=='Escape')return;
    if(welcome&&!welcome.hidden){closeWelcome();return}
    if(stashDlg&&!stashDlg.hidden){closeStash();return}
    if(pwDialog&&!pwDialog.hidden){pwDialog.hidden=true;$('pwWhat').focus();return}
    if(mega&&!mega.hidden){closeMenu();var t=visibleToggle();if(t)t.focus()}
  });

  // Header shadow on scroll
  var top=$('top');
  if(top)window.addEventListener('scroll',function(){top.classList.toggle('scrolled',window.scrollY>8)},{passive:true});
})();
